import React from 'react';
import { FileText, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UtilityBillingSection = () => {
  const navigate = useNavigate();

  const handleNavigateToUtilityBilling = () => {
    navigate('/utility-billing');
  };

  return (
    <div className="mb-8">
      <div 
        onClick={handleNavigateToUtilityBilling}
        className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg shadow-lg p-6 cursor-pointer hover:from-purple-700 hover:to-blue-700 transition-all duration-200 transform hover:scale-105"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <FileText className="h-8 w-8 text-white" />
            </div>
            <div className="ml-4">
              <h3 className="text-xl font-bold text-white">
                Nebenkostenabrechnung
              </h3>
              <p className="text-purple-100 mt-1">
                Erstellen Sie Nebenkostenabrechnungen für Ihre Mieter
              </p>
            </div>
          </div>
          <div className="flex items-center text-white">
            <span className="mr-2 text-sm font-medium">Zur Abrechnung</span>
            <ArrowRight className="h-5 w-5" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UtilityBillingSection;
